import React, { useState, useImperativeHandle, useRef } from 'react';
import { Table, Select, Tooltip } from 'antd';
// import { getPrimaryColor } from 'utils';
import { getPrimaryColor } from '../../../../utils/getPrimaryColor';
import { DeleteOutlined } from '@ant-design/icons';
import { handelcommunityScope } from '../../utils';
import { rightGroupModalType } from '../../config';

import './table.less';
const noop = () => { };
const { Option } = Select;


const MembersTable = React.forwardRef((props, ref) => {
	const { value = [], type, onChange = noop, roleList = [], setroleManModal = noop, allPrivileges = [] } = props;
	const [errors, setErrors] = useState([]);
	// const [ showRoleModal, setRoleModal] = useState(false);
	const validate = () => {
		let noError = true;
		const errors = value.map((item = {}) => {
			const notEmpty = item.roleId !== undefined && item.roleId !== null;
			if (noError && !notEmpty) {
				noError = false;
			}
			return !notEmpty;
		});
		if (value.length === 0) {
			noError = false;
		}

		setErrors(errors);
		return noError;
	};

	useImperativeHandle(ref, () => ({
		validate
	}), [value]);

	const changeRole = (option, index) => {
		const newValue = [...value];
		newValue[index].roleId = option;
		roleList?.some((item) => {
			if (option === item.id) {
				newValue[index].roleName = item.name;
				return true;
			}
			return false;
		});
		validate();
		onChange(newValue);
	};

	const columns = [
		{
			title: '姓名',
			dataIndex: 'target',
			render: (text, record = {}, index) => {
				return <text>{text.targetName}</text>;
			}
		},
		{
			title: '角色',
			width: type === rightGroupModalType.DETAIL ? undefined : '190px',
			dataIndex: 'roleId',
			render: (text, record = {}, index) => {
				if (type === rightGroupModalType.DETAIL) {
					return <span>{record.roleName} </span>;
				}
				return <Select className={errors[index] ? 'table-select error' : 'table-select'} defaultValue={text} value={text} placeholder='请选择' onChange={(option) => { option !== 'addRoleBtn' && changeRole(option, index); }}>
					{
						roleList.map((item, index) => {
							return <Option key={item.id} value={item.id}>{item.name}</Option>;
						})
					}
					<Option key={index + 'addRoleBtn'} value='addRoleBtn' >找不到角色？<span style={{ color: getPrimaryColor(), cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); setroleManModal(); }}>新增角色</span></Option>
				</Select>;
			}
		},
		{
			title: '功能权限',
			dataIndex: 'assignedOperations',
			render: (text = [], record = {}, index) => {
				let assignedOperations = [];
				if (type === rightGroupModalType.DETAIL) {
					assignedOperations = handelcommunityScope(record, allPrivileges);
				} else {
					roleList.some((item) => {
						if (item.id === record.roleId) {
							assignedOperations = handelcommunityScope(item, allPrivileges);
							return true;
						}
						return false;
					});
				}
				return (
					<Tooltip
						title={assignedOperations.map(el => el.name || ' ').join('、')}
						placement='bottomLeft'
						overlayClassName='role-overlay-tip'
					>
						<div>
							{
								assignedOperations.map(el => el.name || ' ').join('、')
							}
						</div>
					</Tooltip>
				);
			}
		}
	];
	type !== rightGroupModalType.DETAIL && columns.push(
		{
			title: '',
			dataIndex: 'deleteBtn',
			width: '40px',
			render: (text = [], record = {}, index) => {
				return <DeleteOutlined onClick={(e) => { const valueNew = [...value]; valueNew.splice(index, 1); onChange(valueNew); }} />;
			}
		}
	);
	return <Table className='rightGroup-table' pagination={false} columns={columns} dataSource={value} />;
});

export default MembersTable;
